import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Draggable } from 'react-beautiful-dnd';
import './style.scss';
import { Scrollbars } from '../../../contexts/scrollBarsContext';
import { addTask, openModal } from '../../../redux/actions';
import { tasksHost } from '../../../settings';
import { Button, Icon, Loader } from '../../../components';
import colors from '../../../utils/colors';
import TaskPreviewModalLayout from '../../Modal/layouts/TaskPreview';

function SingleTask({ id, task, index }) {
	const state = useSelector((state) => state);
	const dispatch = useDispatch();

	const { scrollbars } = Scrollbars();

	const [isLoading, setLoading] = useState(true);

	useEffect(() => {
		const loading = setTimeout(() => {
			setLoading(false);
		}, 1500);

		return () => {
			clearTimeout(loading);
		};
	});

	const handleShowTask = () => {
		dispatch(openModal(<TaskPreviewModalLayout image={taskImg} />, true));
	};

	const handleAddTask = async () => {
		await dispatch(addTask(task, state.editor.test.tasks.length));
		scrollbars.scrollToBottom();
	};

	//load image
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const taskImg = new Image();
	taskImg.src = `${tasksHost}/${task.swf.split('.swf')[0]}.png`;

	//calc image width
	const [taskImgSize, setImgSize] = useState(0);

	useEffect(() => {
		taskImg.addEventListener('load', function () {
			const imgSize = ((this.width / 1024) * 100).toFixed(0);
			if (imgSize > 100) {
				setImgSize(100);
			} else {
				setImgSize(imgSize);
			}
		});

		return () => {
			taskImg.removeEventListener('load', function () {
				const imgSize = ((this.width / 1024) * 100).toFixed(0);
				if (imgSize > 100) {
					setImgSize(100);
				} else {
					setImgSize(imgSize);
				}
			});
		};
	}, [taskImg]);

	return (
		<div className={`task ${isLoading ? 'loading' : ''}`}>
			<div className="task-body">
				{!state.app.isTabletSize && (
					<Draggable draggableId={`tasklist-task-${task['id_pytania']}`} index={index}>
						{(provided, snapshot) => (
							<div
								className={`task-img ${!snapshot.isDragging ? 'disabled-transform' : ''} ${
									isLoading ? 'hidden' : ''
								}`}
								{...provided.draggableProps}
								{...provided.dragHandleProps}
								ref={provided.innerRef}
							>
								<img src={taskImg.src} alt="" style={{ width: `${taskImgSize}%` }} />

								{provided.placeholder}
							</div>
						)}
					</Draggable>
				)}
				<div className={`task-img-placeholder ${isLoading ? 'hidden' : ''}`}>
					<img src={taskImg.src} alt="" style={{ width: `${taskImgSize}%` }} />
				</div>
			</div>
			{isLoading && <Loader type="roller" />}
			<footer className="task-footer">
				<Button color="transparent" onClick={handleShowTask}>
					<span className="btn-label mobile">Zobacz</span>
					<span className="btn-label desktop">Zobacz zadanie</span>
					<Icon name="eye" width="14" height="14" color="#000" />
				</Button>
				<Button color="green-light text-primary" onClick={handleAddTask}>
					<span className="btn-label">Dodaj do testu</span>
					<Icon name="plus" width="14" height="14" color={colors.greenDark} />
				</Button>
			</footer>
		</div>
	);
}

export default SingleTask;
